module.exports = __webpack_public_path__ + "img/show_header.f4272e77.svg";